import React, { useState } from "react";
import { Download, Globe2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { downloadCsv, selectionParams } from "./networkFmt";

export default function NetworkHeader({ sel, loading, onRefreshed }) {
    const [busy, setBusy] = useState(false);

    const refresh = async () => {
        setBusy(true);
        try {
            const r = await api.post("/admin/billing/network/refresh");
            const n = r.data.sync_requested;
            onRefreshed(n ? `Figures updated · ${n} server${n === 1 ? "" : "s"} asked to sync` : "This server's figures are up to date");
        } catch (e) {
            toast.error(formatApiErrorDetail(e));
        } finally {
            setBusy(false);
        }
    };

    const exportTotals = () => downloadCsv("/admin/billing/network/totals.csv", selectionParams(sel), `network-cost-totals_${sel.dateFrom}_${sel.dateTo}.csv`)
        .then(() => toast.success("Totals CSV downloaded"))
        .catch((e) => toast.error(e.message));

    return (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
                <div className="label-xs text-[#7C3AED] flex items-center gap-2"><Globe2 className="w-3 h-3" /> Radar network</div>
                <h2 className="font-display text-2xl tracking-tight mt-2" data-testid="network-costs-title">Network costs</h2>
                <p className="text-xs text-white/50 mt-1 max-w-2xl">
                    AI spend and reuse charges of every server — hub, dev, stage and prod in each region — shared through Radar Sync.
                    The same view on any server. All figures in USD.
                </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
                <button onClick={refresh} disabled={busy} data-testid="network-refresh"
                    className="px-3 py-2 border border-white/15 rounded-md text-xs hover:bg-white/5 transition-colors flex items-center gap-1.5 disabled:opacity-50">
                    <RefreshCw className={`w-3.5 h-3.5 ${busy || loading ? "animate-spin" : ""}`} /> Refresh
                </button>
                <button onClick={exportTotals} data-testid="network-totals-export"
                    className="px-3 py-2 bg-white text-black rounded-md text-xs hover:bg-white/85 transition-colors flex items-center gap-1.5">
                    <Download className="w-3.5 h-3.5" /> Totals CSV
                </button>
            </div>
        </div>
    );
}
